import { render, staticRenderFns } from "./DevolucaoForm.vue?vue&type=template&id=408a2f4e&scoped=true"
import script from "./DevolucaoForm.vue?vue&type=script&lang=js"
export * from "./DevolucaoForm.vue?vue&type=script&lang=js"
import style0 from "./DevolucaoForm.vue?vue&type=style&index=0&id=408a2f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a2f4e",
  null
  
)

export default component.exports